import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, Typography, Container, CssBaseline, CircularProgress } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useNavigate , useLocation  } from 'react-router-dom';
import { setUserInfo, signIn, updatePassInfo } from 'state';
import useSignIn from 'react-auth-kit/hooks/useSignIn';
import Nav from 'components/coloque/Nav';
import {jwtDecode} from 'jwt-decode';
import CountdownTimer from 'components/helper/CountdownTimer';
import Footer from 'components/coloque/Footer';
import BgSVG from '../assets/BgInscription.png'; 
import HeroLogo from '../assets/Hero_logo.png';
import PassConf from '../assets/passConf.png';
import passAll from '../assets/passAll.png';
import cibImg from '../assets/cib.png';
import eccpImg from '../assets/eccp.png';
import retour from '../assets/bouton-retour.png';
import { useGetUserFullInfoQuery, useUpdateUserPassMutation } from '../state/api';
import { useSelector } from 'react-redux';
import WorkshopSlider from 'components/coloque/Workshops';

 

function Login() {
  const { passType, workshop } = useSelector((state) => state.global);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [token, setToken] = useState('');
  const [waiting, setIsWaiting] = useState(false);
  const [paymentMethod ,setPaymentMethod] = useState('eccp');
  const [error, setError] = useState('');
  const [step, setStep] = useState(1);
  const dispatch = useDispatch(); 
  const navigate = useNavigate();
  const signInFunction = useSignIn();
  const [userName, setUserName] = useState('');
  const [userLastName, setUserLastName] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const targetDate = new Date("2024-11-01T23:59:59").getTime();
  const location = useLocation();


  const userData = JSON.parse(sessionStorage.getItem('userData'));
  const userId = userData ? userData.userId : null;
  const { data : userRefetch, error : userError, isLoading : userLoading } = useGetUserFullInfoQuery(userId);



  const deleteCookiesAndSession = () => {
    // Clear session storage
    sessionStorage.clear();

    // Delete cookies by setting their expiration date to the past
    const cookies = document.cookie.split("; ");
    cookies.forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
  };
  

  const [selectedPass, setSelectedPass] = useState(null);
  const [workShop, setWorkShop] = useState(null);

  const [updateUserPass] = useUpdateUserPassMutation();

  const handleConfirmPass = async () => {
    if (selectedPass === "conference" || selectedPass === "all") {
      try {
        const userData = JSON.parse(sessionStorage.getItem('userData'));
        const userId = userData ? userData.userId : null;
        
        const res = await updateUserPass({
          userId,
          passType: selectedPass,
          workshop: selectedPass === "all" ? workShop : null, // Set workshop if pass is "all"
        });


        if(res){
          setSelectedPass(res?.data?.passType);
          setWorkShop(res?.data?.workshop);
          updatePassInfo({ passType: res?.data?.passType , workshop: res?.data?.workshop })
          setStep(3);
        }
        
         // Move to step 3 if pass confirmed
      } catch (error) {
        console.error("Error updating pass:", error);
      }
    }
  };

  

  // Check if user is already logged in and redirect to Step 2 if they are
  const fetchUserInfo = async () => {
    if (userRefetch) {
      try {
        // Store only the necessary parts of userRefetch in sessionStorag
  
        setSelectedPass(userRefetch.passType);
        setWorkShop(userRefetch.workshop);
  
        // Set step based on passType presence
        setStep(3);
      } catch (error) {
        console.error('Failed to fetch user info:', error);
        // Optionally, redirect to login page if token is invalid or expired
        navigate('/home');
      }
    } else {
      setStep(2); // If no token is saved, stay on step 1
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const savedToken = sessionStorage.getItem('token');
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const apiUrl = process.env.REACT_APP_API_URL;



    const verifyToken = async (token) => {
      try {
        const response = await axios.post(`${apiUrl}/user/signin`, { token }, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

  

        if (response.status === 200) {
          // Token is valid; proceed with sign-in using response data
          handleSignIn(response.data);
          setToken(response.data.token);
          setIsSignedIn(true);
        
          window.location.href('/auth');
          

          
          /* if(response.data.passType === "all" || response.data.passType === "conference"){
            setSelectedPass(response?.data?.passType);
            setWorkShop(response?.data?.workshop);
            updatePassInfo({ passType: response?.data?.passType , workshop: response?.data?.workshop })
            setStep(3);
          }else{
            setStep(2); // Proceed to Step 2 after successful login
          } */
        } else {
          deleteCookiesAndSession(); 
          setError("Token is invalid or expired. Please log in.");
          navigate('/auth'); // Redirect if token is invalid

        }
      } catch (error) {
        deleteCookiesAndSession();
        console.error("Token verification failed:", error);
        setError("Token verification failed. Please log in.");
        navigate('/auth');
      }
    };

    if (token) {
      verifyToken(token);
    }
    
    
  
    if (userData) {
      if (userData.userName && userData.userLastName) {
        setUserName(userData.userName); 
        setUserLastName(userData.userLastName);
        if(userData.passType){
          
        }
      }
      if (savedToken) {
        setStep(2); // Go to step 2 if the user is logged in but has not selected a pass
      }
      // Check if passType is already set to determine if user should go to step 3
      if (userRefetch?.passType) {
        fetchUserInfo();
      }
    }
  }, [userRefetch]);

  const handlePassSelect = (passType) => {
    setSelectedPass(passType);
  };

  // Handle user sign-in after form submission
  const handleSignIn = async (userData) => {
    try {
      await signInFunction({
        auth: {
          token: userData.token,
          type: 'Bearer',
        }
      });
      
      sessionStorage.setItem('token', userData.token);
      sessionStorage.setItem('userData', JSON.stringify({
        userId: userData.userId,
        userName: userData.name,
        userEmail: userData.userEmail,
        userRole: userData.role,
        userLastName: userData.lastName,
        img: userData.img,
        workshop : userData.workshop,
        passType : userData.passType
      }));
      dispatch(signIn(userData.token));
      dispatch(
        setUserInfo({
          userId: userData.userId,
          userName: userData.name,
          userEmail: userData.userEmail,
          userRole: userData.role,
          userLastName: userData.lastName,
          img: userData.img,
          workshop : userData.workshop,
          passType : userData.passType
        })
      );
      setUserName(userData.name);
      setUserLastName(userData.lastName);
      setStep(2); // Proceed to Step 2 after successful login
    } catch (error) {
      console.error('Error during sign-in:', error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsWaiting(true);

    const formData = {
      email: document.querySelector('#email').value,
      phone: document.querySelector('#phone').value,
      firstName: document.querySelector('#firstName').value,
      lastName: document.querySelector('#lastName').value,
      company: document.querySelector('#company').value,
      position: document.querySelector('#position').value,
    };

    const apiUrl = process.env.REACT_APP_API_URL;

    try {
      const response = await axios.post(`${apiUrl}/user/signup`, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 201) {
        // Successful login
        setToken(response.data.token);
        setIsSignedIn(true);
        handleSignIn(response.data); // Log user and proceed to Step 2
      } else {
        setError('Failed to sign in. Please check your details.');
      }
    } catch (error) {
      console.error('Error:', error);
      setError(error.response.data.error || 'Unknown error occurred');
    } finally {
      setIsWaiting(false);
    }
  };

  // Render Step 1: Account Creation Form
  const renderStep1 = () => (
    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, pb: 5 }}>
      <Box sx={{ display: 'flex', gap: 2, mb: 8 }}>
        <TextField 
          id="firstName" 
          placeholder="Nom" 
          fullWidth 
          required 
          variant="standard" 
          InputProps={{
            sx: { fontSize: '1.2em' }
          }}
        />
        <TextField 
          id="lastName" 
          placeholder="Prénom" 
          fullWidth 
          required 
          variant="standard" 
          InputProps={{
            sx: { fontSize: '1.2em' }
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 2, mb: 8 }}>
        <TextField 
          id="email" 
          placeholder="Adresse email" 
          fullWidth 
          required 
          variant="standard" 
          InputProps={{
            sx: { fontSize: '1.2em' }
          }}
        />
        <TextField 
          id="phone" 
          placeholder="Téléphone" 
          fullWidth 
          required 
          variant="standard" 
          InputProps={{
            sx: { fontSize: '1.2em' }
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 2, mb: 8 }}>
        <TextField 
          id="company" 
          placeholder="Entreprise / Institution" 
          fullWidth 
          required 
          variant="standard" 
          InputProps={{
            sx: { fontSize: '1.2em' }
          }}
        />
        <TextField 
          id="position" 
          placeholder="Poste" 
          fullWidth 
          required 
          variant="standard" 
          InputProps={{
            sx: { fontSize: '1.2em' }
          }}
        />
      </Box>

          {/* Error Message */}
    {error && (
      <Typography color="error" sx={{ mb: 2 }}>
        {error}
      </Typography>
    )}

      <Button
        type="submit"
        fullWidth
        variant="contained"
        style={{ backgroundColor: '#00e5ff', color: '#000', marginTop: '30px', padding: '15px 0' }}
        disabled={waiting}
      >
        {waiting ? <CircularProgress size={24} sx={{ color: '#000' }} /> : "Continuer"}
      </Button>
    </Box>
  );

  // Placeholder for Step 2 content
  const renderStep2 = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2em',
        textAlign: 'center',
        backgroundColor: '#fff',
        borderRadius: '8px',
        
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 , fontSize : isMobile ? "24px" : "34px" }}>
        Bienvenu, {userName} {userLastName}
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Veuillez choisir votre pass
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center', // Centers items vertically
          justifyContent: 'center', // Centers items horizontally
          gap: '2em',
          justifyContent: 'center',
          mb: isMobile ? 4 : 10,
        }}
      >
        {/* Pass Option 1 */}
        <Box>
        <Typography variant="body1" sx={{ mb: 3 , fontWeight :"bold"}}>
        Access to conference only
        </Typography>
        <Box
          onClick={() => handlePassSelect('conference')}
          sx={{
            position :"relative",
            cursor: 'pointer',
            width: isMobile ? '100%' : '300px',
            height: '200px',
            borderRadius: '10px',
            overflow: 'visible',
            border: selectedPass === 'conference' ? '4px solid #00e5ff' : '4px solid transparent',
            boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
            transition: 'border-color 0.3s ease',
            background: `url(${PassConf}) no-repeat center`,
            backgroundSize: 'cover',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '1em',
            color: '#fff',
          }}
        >
          <Typography variant="h6">Pass Conference</Typography>
          <Typography sx={{
             display : !isMobile ? 'none' : "inline-block",
          }} variant="h6">Gratuit</Typography>
          <Typography
          sx={{
            display : isMobile ? 'none' : "inline-block",
            position: "absolute",
            bottom: "-15.3em", // Adjust for alignment
            backgroundColor: "#165B8E",
            padding: ".3em",
            clipPath: "ellipse(50% 25% at 50% 0%)",
            width: "11em",
            height :"15em",
            textAlign: "center",
          }}
          variant="body2">Gratuit</Typography>
        </Box>
        </Box>

        {/* Pass Option 2 */}
        <Box>
        <Typography variant="body1" sx={{ mb: 3 , fontWeight :"bold"}}>
        Conference incluse + Un seul atelier au choix
        </Typography>
        <Box
          onClick={() => handlePassSelect('all')}
          sx={{
            position :"relative",
            cursor: 'pointer',
            width: isMobile ? '100%' : '300px',
            height: '200px',
            borderRadius: '10px',
            overflow: 'visible',
            border: selectedPass === 'all' ? '4px solid #00e5ff' : '4px solid transparent',
            boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
            transition: 'border-color 0.3s ease',
            background: `url('${passAll}') no-repeat center`,
            backgroundSize: 'cover',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '1em',
            color: '#fff',
          }}
        >
          <Typography variant="h6">Pass All</Typography>
          <Typography sx={{
             display : !isMobile ? 'none' : "inline-block",
          }} variant="h6">Payant 25,000 DA</Typography>
          <Typography 
          sx={{
            display : isMobile ? 'none' : "inline-block",
            position: "absolute",
            bottom: "-15.3em", // Adjust for alignment
            backgroundColor: "#165B8E",
            padding: ".3em",
            clipPath: "ellipse(50% 25% at 50% 0%)",
            width: "11em",
            height :"15em",
            textAlign: "center",
          }}
          variant="body2">Payant 25,000 DA</Typography>
        </Box>
        </Box>
      </Box>

      {selectedPass === "all" && (
  <Box
    sx={{
      display: 'none',
      flexDirection: 'row',
      justifyContent :"center",
      gap: '1em', // Adds spacing between buttons
      width: isMobile ? "50" : '100%',
      margin: '2em 0em',
    }}
  >
    <Button
  onClick={() => setPaymentMethod('eccp')}
  sx={{
    display :"none",
    width: isMobile ? "10em" : '20%', // Adjust width as needed
    height: 'auto',
    margin: "0",
    background: "transparent",
    borderRadius: '15px',
    border: paymentMethod === 'eccp' ? '4px solid #00e5ff' : '4px solid transparent', // Conditional border
    boxShadow: paymentMethod === 'eccp' ? '0 4px 15px rgba(0,0,0,0.2)' : 'none', // Apply shadow only when selected
    transition: 'border-color 0.3s ease',
    padding: 0, // Remove any padding
    minWidth: 0, // Prevents the button from stretching
    minHeight: 0, // Ensures no extra space around the image
  }}
>
  <img
    width="100%"
    src={eccpImg}
    style={{
      border: 0,
      borderRadius: '8px', // Matches the button’s border radius
      display: 'block', // Removes any inline spacing around the image
      
    }}
  />
</Button>

    <Button
      onClick={() => setPaymentMethod('cib')}
      sx={{
        display :"none",
        width: isMobile ? "10em" : '20%', // Adjust width as needed
        height: 'auto',
        margin: "0",
        background: "transparent",
        borderRadius: '15px',
        border: paymentMethod === 'cib' ? '4px solid #00e5ff' : '4px solid transparent', // Conditional border
        boxShadow: paymentMethod === 'cib' ? '0 4px 15px rgba(0,0,0,0.2)' : 'none', // Apply shadow only when selected
        transition: 'border-color 0.3s ease',
        padding: 0, // Remove any padding
        minWidth: 0, // Prevents the button from stretching
        minHeight: 0, // Ensures no extra space around the image
      }}
    >
      <img width={"100%"} src={cibImg} />
    </Button>
  </Box>
)}


<Button
      variant="contained"
      disabled={paymentMethod === "" && selectedPass != "conference" ? true : paymentMethod === "eccp" || paymentMethod === "cib" ? false : selectedPass === "conference" ? false : true}
      style={{
        backgroundColor: paymentMethod === "" && selectedPass != "conference" ? '#ccc' : paymentMethod === "eccp" || paymentMethod === "cib" ? "#00e5ff" : selectedPass === "conference" ? '#00e5ff' : "#ccc",
        color: '#000',
        padding: '15px 30px',
        borderRadius: '20px',
      }}
      onClick={handleConfirmPass}
    >
      {selectedPass === "conference" ? "Confirmer Mon Inscription" : selectedPass === "all" ? "Choisissez l'atelier et payez" : "Veuillez sélectionner une option ci-dessus"}
    </Button>
      <Typography variant="body2" sx={{ mt: 2, color: '#888' }}>
        Votre Badge Sera Envoyé Par Email
      </Typography>
    </Box>
  );


  const renderStep3 = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2em',
        textAlign: 'center',
        backgroundColor: '#fff',
        borderRadius: '8px',
      }}
    >
     

      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 , fontSize : isMobile ? "24px" : "34px" }}>
        Bienvenu, {userName} {userLastName}
      </Typography>

      {
        userRefetch.passType === "conference" && 
        <Typography variant="body1" sx={{ mb: 3 }}>
        Vous avez le PASS {userRefetch?.passType}
      </Typography>
      }



      {
        userRefetch.passType === "all" && 
        <Box>
          <Typography variant="body1" sx={{ mb: 3 }}>
        Vous avez choisi le PASS All <br/>
        Consulter nos ateliers
      </Typography>
      <WorkshopSlider lockedWP={userRefetch.workshop} />
   
        </Box>
      }     
      

      
        
        
      
    </Box>
  );

  return (
    <Box>
      <Nav bg={'transparent'} />
      <Box
        style={{
          background: `url(${BgSVG}) no-repeat center center`,
          position: "relative",
          backgroundSize: 'cover',
          height: '400px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#fff',
          textAlign: 'center',
        }}
      >
        <Typography sx={{
          fontSize : isMobile ? "34px" : "auto",
        }} variant="h1" style={{ fontWeight: 'bold' }}>
          Bienvenue dans la page d'inscription
        </Typography>
        <Typography variant="h6" style={{ marginTop: '10px' }}>
          Inscrivez-vous dès maintenant et obtenez une place sur le Plus Grand Colloque sur le Numérique et la Technologie
        </Typography>
        <Typography variant="body2" style={{ marginTop: '5px' }}>
          Nusa Dua, Bali - Indonesia &nbsp;&nbsp;|&nbsp;&nbsp; November 14 - 16, 2022
        </Typography>
        <Box
          sx={{
            display: "flex",
            position: "absolute",
            bottom: isMobile ? "-6em" : "-4.4em",
            width: isMobile ? "100%" : "693.7px", // Full width on mobile
            height: "8.75em",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
            backgroundColor: "#001B30",
            borderRadius: isMobile ? "0px" : "10px",
            boxShadow: "0px 5px 25px 0px rgba(4, 3, 3, 0.15)",
            padding: "1em",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: `url(${HeroLogo})`,
              backgroundSize: "100% 419.715%",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "0px -286.601px",
              opacity: 0.2, // Reduce opacity to make the background less visible
              zIndex: 1,
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              zIndex: 2,
              color: "#FFFFFF",
              fontSize: isMobile ? ".8em" : "1.5em",
              textAlign: "center",
              width: "100%",
            }}
          >
            <CountdownTimer targetDate={targetDate} isMobile={isMobile} />
          </Box>
        </Box>
      </Box>

      <Container sx={{ paddingTop: "5em", paddingBottom: "3em" }} component="main" maxWidth="md">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            alignItems: 'center',
            backgroundColor: '#fff',
            borderRadius: '8px',
            padding: '5em',
            boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.2)',
            position :"relative"
          }}
        > 
           {step === 3 && 
            <Button variant="h6" sx={{
              position :"absolute",
              fontSize : isMobile ? "24px" : "34px",
              color :"Black",
              top :"5px",
              left :"15px",
              textDecoration :"none",
              borderBottom : "2px solid black",
              cursor :"pointer",
              userSelect :"none"
            }} onClick={() => {
              setStep(step-1);
            }} >
              <img width={isMobile ? 18 : 24} src={retour} /> Retour
            </Button>
           }
          {step === 1 ? renderStep1() : step === 2 ? renderStep2() : step === 3 ? renderStep3() : null}
        </Box>
      </Container>
      <Footer />
    </Box>
  );
}

export default Login;
